module.exports = __webpack_public_path__ + "img/ration-pig.394a00a0.webp";